import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { Action, ActionCreator, Store } from '@ngrx/store';
import { firstValueFrom, map } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import {
  IInfoConfirmationDialogData,
  InfoConfirmationDialogComponent,
} from '@shared/dialogs/info-confirmation-dialog/info-confirmation-dialog.component';
import { Dialog } from '@angular/cdk/dialog';
import { UpperCasePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { InformationBoxComponent } from '../../../../shared/information-box/information-box.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
export interface IBulkConfirmationDialogData {
  negativeAction?: boolean;
  singularEntityType: string;
  dialogIcon: string;
  pluralEntityType: string;
  confirmationButtonText: string;
  selectedEntityNames: string[];
  confirmationText: string;
  infoBoxText?: string;
  definiteArticle: boolean;
  dispatchAction: Action;
  successAction: ActionCreator;
  errorAction: ActionCreator;
  confirmationDialog?: IInfoConfirmationDialogData;
}

@Component({
  selector: 'app-bulk-confirmation-dialog',
  templateUrl: './bulk-confirmation-dialog.component.html',
  styleUrls: ['./bulk-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatProgressBarModule,
    MatDialogTitle,
    MatIconModule,
    MatDialogContent,
    InformationBoxComponent,
    MatDialogActions,
    FlexLayoutModule,
    MatButtonModule,
    UpperCasePipe,
  ],
})
export class BulkConfirmationDialogComponent {
  remainingExpanded = false;
  inProgress = false;
  get firstTwoEntityNames(): string[] {
    return this.data.selectedEntityNames.slice(0, 2);
  }
  get remainingEntityCount(): number {
    return this.data.selectedEntityNames.length - 2;
  }
  constructor(
    private _dialogRef: MatDialogRef<BulkConfirmationDialogComponent>,
    private _store: Store,
    @Inject(MAT_DIALOG_DATA) public data: IBulkConfirmationDialogData,
    private _action: Actions,
    private _dialog: MatDialog
  ) {}
  async closeDialog(confirmed: boolean): Promise<void> {
    if (confirmed) {
      const confirmationDialog = this.data.confirmationDialog;
      if (
        confirmationDialog &&
        !(await firstValueFrom(
          this._dialog
            .open<
              InfoConfirmationDialogComponent,
              IInfoConfirmationDialogData,
              boolean
            >(InfoConfirmationDialogComponent, {
              data: confirmationDialog,
            })
            .afterClosed()
        ))
      ) {
        return;
      }
      this.inProgress = true;
      this._store.dispatch(this.data.dispatchAction);

      await firstValueFrom(
        this._action.pipe(
          ofType(this.data.successAction, this.data.errorAction),
          map((action) => void 0)
        )
      );
      this.inProgress = false;
    }
    this._dialogRef.close(confirmed);
  }
}
